// reCAPTCHA v3 site key — the same key the logged-out routes load
// (see routes/loggedOutRoutes.js). Pages outside that tree (e.g. logged-in
// gift purchase) wrap themselves in a provider using this key.
export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6Lf1NZsrAAAAAHEtJwU8Ta4krTKEElLNaunFihcb";
